<template>
  <div class="container">
    <ul class="nav nav-tabs nav-tabs-c">
      <li role="presentation" v-link="{path: '/route/' + $route.params.id + '/basic', activeClass: 'active'}" ><a href="javascript:void(0);">基本信息</a></li>
      <li role="presentation" v-link="{path: '/route/' + $route.params.id + '/assembling', activeClass: 'active'}" ><a href="javascript:void(0);">集合信息</a></li>
      <li role="presentation" v-link="{path: '/route/' + $route.params.id + '/itinerary', activeClass: 'active'}" ><a href="javascript:void(0);">行程安排</a></li>
      <li role="presentation" v-link="{path: '/route/' + $route.params.id + '/focus', activeClass: 'active'}" ><a href="javascript:void(0);">活动亮点</a></li>
      <li role="presentation" v-link="{path: '/route/' + $route.params.id + '/notice', activeClass: 'active'}" ><a href="javascript:void(0);">费用&注意事项</a></li>
      <li role="presentation" v-link="{path: '/route/' + $route.params.id + '/images', activeClass: 'active'}" ><a href="javascript:void(0);">图片&视频</a></li>
    </ul>
    <router-view :route="route"></router-view>
  </div>
</template>
<script>
  import config from '../../libs/config.js'

  export default {
    data () {
      return {
        route: {}
      }
    },
    methods: {
      fetchInfo () {
        return this.$http.get(config.apiWe + '/product/route/' + this.$route.params.id + '?admin=yes')
          .then(({data}) => {
            this.$set('route', data)
          })
      }
    },
    route: {
      data ({next}) {
        this.fetchInfo()
          .then(next)
      },
      waitForData: true
    }
  }
</script>
<style scoped>
  .nav-tabs-c {
    margin-bottom: 20px;
  }
</style>



/** WEBPACK FOOTER **
 ** ItemWraper.vue?752b7563
 **/